import "./Header.css";

export default function Header() {
  return (
    <header className="header">
      <img src="/img/HeaderHeader_total.png" alt="cabecera" />
    </header>
  );
}
